import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map, noop } from 'lodash';
import ListForm from '../../../components/ListForm/ListForm.component';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { commaFormatted, normalizeAmount } from '../../../utils/transformer.util';
import {  KELOLA_KENAIKANKELAS_DATAKELAS_TABLE_FIELDS } from '../../../constants/Akademi/DataKelas/kelas.constant';
import {  KELOLA_KENAIKANKELAS_DATAKELAS_FORM_FIELDS } from '../../../constants/Akademi/DataKelas/kelas.constant';
import { Button, Select } from '../../../components/base';
import { SEARCH_FIELDS} from '../../../constants/Akademi/DataKelas/kelas.constant';


export default class Kelola extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._onClickBack = this._onClickBack.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);

    //this.deletePlafon = this.deletePlafon.bind(this);
    //this._onAddList = this._onAddList.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    
    this.state = {
      form: {
        value: {
          
        },
        error: {
         

        },
      },
      
    };
  }

  componentDidMount() {
    const { handleGetClasses  } = this.props;
    handleGetClasses();
  }
  // on formchange untuk form
  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
      };
    });
  }

  _onClickAdd(data) {
    const { form } = this.state;
    const { plafon } = form.value;
    
    plafon.push({
      tipePlafon: '',
      // divisi: '',
      nominal: 0,
      //period:'',
    });
    
    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          plafon,
        },
        error: {
          ...prevState.form.error,
        }
      }
    }));
    console.log(plafon)
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { plafon } = prevState.form.value;
      const list = prevState.form.value.plafon;

      list.splice(idx, 1);
      return {
        ...prevState,
        plafon: list
      };
    });
  }

  // on formchange untuk tabel
  onFormChange(event) {
    const {
      name,
      value,
      dataset,
    } = event.target;
    console.log(name)
    const { inputArray = false, arrayPosition = 0, inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      let newPlafon = [];
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        newPlafon = prevState.form.value.plafon;
        newPlafon[arrayPosition][name] = value;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray ? 
              { plafon: newPlafon } : 
              { [name]: formattedValue }
            )
          },
          error: {
            ...prevState.form.error,
            form:'',
            [name]: '',
          },
        },
      };
    });
  }

  _onClickBack(e) {
      e.preventDefault()
    const { history } = this.props;
    history.push('/dashboard/pengaturan/buat-identitas-sekolah');
  }
  
  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    //handleAddBudget(form.value, history.goBack, unit_id);
  }

  deletePlafon(e) {
    var array = [...this.state.people]; // make a separate copy of the array
    var index = array.indexOf(e.target.value)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({people: array});
    }
  }

  render() {
    const { form } = this.state;
    const {value} = form;
    const { handleGetBudget,coa, classes={} } = this.props;
    return (
      <div className="add-budget">
        <div className="budget__title">
        <h1>Kenaikan Kelas Siswa</h1>
        <hr></hr>
        </div>
        <form onSubmit={this.onSubmit}>
          {/* <ListForm
            form={form}
            formFields={ KELOLA_KENAIKANKELAS_DATAKELAS_FORM_FIELDS}
            onFormChange={this._onFormChange}
          /> */}
          <Select
            name="classes"
            label="Siswa Kelas"
            onChange={this._onFormChange}
            placeholder="All Kelas"
            // data={classes.list}
            // value={value.classes}
          />
          <Select
            name="classes"
            label="Akan Naik ke Kelas"
            onChange={this._onFormChange}
            placeholder="Pilih Kelas"
            data={classes.list}
            value={value.classes}
          />
         
        <div className="budget__content">
          <div className="budget__search">
          <ListForm
          coa={coa}
          form={form}
          formFields={SEARCH_FIELDS}
          onFormChange={this._onFormChange}
          />
          </div>
         <ContentTable
            onSearchContent={handleGetBudget}
            tableFields={KELOLA_KENAIKANKELAS_DATAKELAS_TABLE_FIELDS}
           
          />
        </div>
          

          <div className="add-budget">
            <Button
              type="submit"
              title="SIMPAN"
            />
          </div>
        </form>
      </div>
    );
  }

    //   render() {
    //     return (
    //         <ul>
    //             {this.props.items.map(item => (
    //                 <li key={item.id}>{item.text}<button onClick={this._handleDelete.bind(this, item.id)}>Delete</button></li>
    //             ))}
    //         </ul>
    //     );
    // } 
}
Kelola.propTypes = {
  handleAddBudget: PropTypes.func,
  handleGetClasses: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
Kelola.defaultProps = {
  handleAddBudget: noop,
  handleGetClasses: noop,
  user: null,
};
